const CookieConfig = {
    auth_id: 'luna_auth_id'
}

export default CookieConfig;
